import _get from 'lodash/get';

export default function addAtcReqId() {
    return (ctx) => {
        if (typeof window === 'undefined') {
            ctx.data.ATC_REQID = _get(ctx, 'req.transactionId', '');
        }
    };
}
